import type { BannerItem } from "@/types/content";

export const banners: BannerItem[] = [
  {
    id: "b1",
    tag: "行情快讯",
    title: "国际金价重返2650美元上方 降息预期升温",
    description:
      "受美联储降息预期推动，国际现货黄金日内上涨逾0.6%，美元指数同步走弱，避险与配置资金持续流入。",
    image:
      "https://readdy.ai/api/search-image?query=Sweeping%20abstract%20financial%20background%20of%20glowing%20golden%20candlestick%20charts%20rising%20through%20a%20deep%20navy%20blue%20night%20sky%2C%20soft%20bokeh%20light%20specks%2C%20elegant%20premium%20ecommerce%20hero%20aesthetic%2C%20high%20detail%2C%20cinematic%20composition&width=1600&height=900&seq=banner-01&orientation=landscape",
    time: "2026-10-12 15:30",
    link: "/detail/price/london-gold",
    highlight: "XAUUSD 2648.70",
  },
  {
    id: "b2",
    tag: "市场分析",
    title: "央行连续增持 黄金中长期底部再获支撑",
    description:
      "官方储备数据显示全球央行持续增持黄金，储备结构多元化趋势清晰，为金价提供较为稳固的中长期支撑。",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20luxurious%20background%20of%20stacked%20gold%20bars%20in%20a%20vault%20with%20deep%20navy%20shadows%20and%20warm%20golden%20rim%20lighting%2C%20premium%20financial%20editorial%20hero%20aesthetic%2C%20high%20detail%2C%20cinematic%20depth&width=1600&height=900&seq=banner-02&orientation=landscape",
    time: "2026-10-10 09:15",
    link: "/detail/news/n3",
    highlight: "官方储备",
  },
  {
    id: "b3",
    tag: "机构展望",
    title: "多家机构上调黄金目标价至2800美元",
    description:
      "降息周期、央行购金与地缘不确定性构成三大主线，研究机构对金价的中长期前景保持乐观预期。",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20financial%20hero%20background%20of%20a%20golden%20upward%20arrow%20and%20grid%20of%20price%20charts%20over%20a%20deep%20navy%20gradient%2C%20warm%20glowing%20accents%2C%20premium%20editorial%20aesthetic%2C%20high%20detail%2C%20cinematic&width=1600&height=900&seq=banner-03&orientation=landscape",
    time: "2026-10-04 11:00",
    link: "/detail/news/n9",
    highlight: "目标价 2800",
  },
];